import clsx from 'clsx'
import { FieldErrors, UseFormRegister, UseFormWatch } from 'react-hook-form'
import isMobilePhone from 'validator/es/lib/isMobilePhone'
import isPostalCode from 'validator/es/lib/isPostalCode'
import { FieldValues } from './RecipientsInformation'

const ShippingAddressAndPhoneNumber = ({
  errors,
  isGift,
  register,
  watch,
}: {
  errors: FieldErrors<FieldValues>
  isGift: boolean
  register: UseFormRegister<FieldValues>
  watch: UseFormWatch<FieldValues>
}) => (
  <div>
    <fieldset className="form-item">
      <legend>
        {!isGift && <span>Shipping address and phone number*</span>}
        {isGift && <span>Recipient’s shipping address and phone number*</span>}
      </legend>
      <div>
        <div>
          <div id="edit-address">
            <div>
              <div className="form-item js-form-type-select">
                <select
                  aria-label="Country"
                  className={clsx(
                    'form-select',
                    errors.address?.country_code && 'error'
                  )}
                  id="edit-address-country-code--2"
                  {...register('address.country_code', {
                    required: 'Field is required',
                  })}
                >
                  <option value="CA">Canada</option>
                  <option value="US">United States</option>
                </select>
                {errors.address?.country_code && (
                  <div className="form-item--error-message">
                    {errors.address?.country_code.message}
                  </div>
                )}
              </div>
            </div>
            <div className="form-item">
              <label htmlFor="edit-address-address-line1">Street address</label>
              <input
                className={clsx(
                  'form-text',
                  errors.address?.address_line1 && 'error'
                )}
                id="edit-address-address-line1"
                placeholder=" "
                size={60}
                {...register('address.address_line1', {
                  validate: (value) => {
                    if (!value) {
                      return 'Field is required'
                    }
                    if (value.length > 35) {
                      return 'Field is limited to 35 characters'
                    }
                    return undefined
                  },
                })}
              />
              {errors.address?.address_line1 && (
                <div className="form-item--error-message">
                  {errors.address?.address_line1.message}
                </div>
              )}
            </div>
            <div className="form-item">
              <label
                className="visually-hidden"
                htmlFor="edit-address-address-line2"
              >
                Street address line 2
              </label>
              <input
                autoComplete="address-line2"
                className={clsx(
                  'form-text',
                  errors.address?.address_line2 && 'error'
                )}
                id="edit-address-address-line2"
                size={60}
                type="text"
                {...register('address.address_line2', {
                  validate: (value) => {
                    if (value && value.length > 35) {
                      return 'Field is limited to 35 characters'
                    }
                    return undefined
                  },
                })}
              />
              {errors.address?.address_line2 && (
                <div className="form-item--error-message">
                  {errors.address?.address_line2.message}
                </div>
              )}
            </div>
            <div id="edit-address-container3">
              <div className="form-item form-item-address-locality">
                <label htmlFor="edit-address-locality">City</label>
                <input
                  className={clsx(
                    'form-text',
                    errors.address?.locality && 'error'
                  )}
                  id="edit-address-locality"
                  placeholder=" "
                  size={30}
                  type="text"
                  {...register('address.locality', {
                    validate: (value) => {
                      if (!value) {
                        return 'Field is required'
                      }
                      if (value.length > 35) {
                        return 'Field is limited to 35 characters'
                      }
                      return undefined
                    },
                  })}
                />
                {errors.address?.locality && (
                  <div className="form-item--error-message">
                    {errors.address?.locality.message}
                  </div>
                )}
              </div>
              <div className="form-item js-form-type-select form-item-address-administrative-area">
                <select
                  className={clsx(
                    'form-select',
                    errors.address?.administrative_area && 'error'
                  )}
                  id="edit-address-administrative-area"
                  {...register('address.administrative_area', {
                    required: 'Field is required',
                  })}
                >
                  {watch('address.country_code') === 'CA' && (
                    <>
                      <option value="">Province</option>
                      <option value="AB">Alberta</option>
                      <option value="BC">British Columbia</option>
                      <option value="MB">Manitoba</option>
                      <option value="NB">New Brunswick</option>
                      <option value="NL">Newfoundland and Labrador</option>
                      <option value="NS">Nova Scotia</option>
                      <option value="ON">Ontario</option>
                      <option value="PE">Prince Edward Island</option>
                      <option value="QC">Quebec</option>
                      <option value="SK">Saskatchewan</option>
                      <option value="NT">Northwest Territories</option>
                      <option value="NU">Nunavut</option>
                      <option value="YT">Yukon</option>
                    </>
                  )}
                  {watch('address.country_code') === 'US' && (
                    <>
                      <option value="">State</option>
                      <option value="AL">Alabama</option>
                      <option value="AK">Alaska</option>
                      {/*<option value="AS">American Samoa</option>*/}
                      <option value="AZ">Arizona</option>
                      <option value="AR">Arkansas</option>
                      <option value="AA">Armed Forces (AA)</option>
                      <option value="AE">Armed Forces (AE)</option>
                      <option value="AP">Armed Forces (AP)</option>
                      <option value="CA">California</option>
                      <option value="CO">Colorado</option>
                      <option value="CT">Connecticut</option>
                      <option value="DE">Delaware</option>
                      <option value="DC">District of Columbia</option>
                      <option value="FL">Florida</option>
                      <option value="GA">Georgia</option>
                      {/*<option value="GU">Guam</option>*/}
                      <option value="HI">Hawaii</option>
                      <option value="ID">Idaho</option>
                      <option value="IL">Illinois</option>
                      <option value="IN">Indiana</option>
                      <option value="IA">Iowa</option>
                      <option value="KS">Kansas</option>
                      <option value="KY">Kentucky</option>
                      <option value="LA">Louisiana</option>
                      <option value="ME">Maine</option>
                      {/*<option value="MH">Marshall Islands</option>*/}
                      <option value="MD">Maryland</option>
                      <option value="MA">Massachusetts</option>
                      <option value="MI">Michigan</option>
                      {/*<option value="FM">Micronesia</option>*/}
                      <option value="MN">Minnesota</option>
                      <option value="MS">Mississippi</option>
                      <option value="MO">Missouri</option>
                      <option value="MT">Montana</option>
                      <option value="NE">Nebraska</option>
                      <option value="NV">Nevada</option>
                      <option value="NH">New Hampshire</option>
                      <option value="NJ">New Jersey</option>
                      <option value="NM">New Mexico</option>
                      <option value="NY">New York</option>
                      <option value="NC">North Carolina</option>
                      <option value="ND">North Dakota</option>
                      {/*<option value="MP">Northern Mariana Islands</option>*/}
                      <option value="OH">Ohio</option>
                      <option value="OK">Oklahoma</option>
                      <option value="OR">Oregon</option>
                      {/*<option value="PW">Palau</option>*/}
                      <option value="PA">Pennsylvania</option>
                      {/*<option value="PR">Puerto Rico</option>*/}
                      <option value="RI">Rhode Island</option>
                      <option value="SC">South Carolina</option>
                      <option value="SD">South Dakota</option>
                      <option value="TN">Tennessee</option>
                      <option value="TX">Texas</option>
                      <option value="UT">Utah</option>
                      <option value="VT">Vermont</option>
                      {/*<option value="VI">Virgin Islands</option>*/}
                      <option value="VA">Virginia</option>
                      <option value="WA">Washington</option>
                      <option value="WV">West Virginia</option>
                      <option value="WI">Wisconsin</option>
                      <option value="WY">Wyoming</option>
                    </>
                  )}
                </select>
                {errors.address?.administrative_area && (
                  <div className="form-item--error-message">
                    {errors.address?.administrative_area.message}
                  </div>
                )}
              </div>
              <div className="form-item form-item-address-postal-code">
                {watch('address.country_code') === 'CA' && (
                  <label htmlFor="edit-address-postal-code">Postal code</label>
                )}
                {watch('address.country_code') === 'US' && (
                  <label htmlFor="edit-address-postal-code">Zip code</label>
                )}
                <input
                  className={clsx(
                    'form-text',
                    errors.address?.postal_code && 'error'
                  )}
                  id="edit-address-postal-code"
                  placeholder=" "
                  size={10}
                  type="text"
                  {...register('address.postal_code', {
                    validate: (value) => {
                      if (!value) {
                        return 'Field is required'
                      }
                      if (value.length > 15) {
                        return 'Field is limited to 15 characters'
                      }
                      if (watch('address.country_code') === 'CA') {
                        if (!isPostalCode(value, 'CA')) {
                          return 'Valid postal code required'
                        }
                      } else if (!isPostalCode(value, 'US')) {
                        return 'Valid ZIP code required'
                      }
                      return undefined
                    },
                  })}
                />
                {errors.address?.postal_code && (
                  <div className="form-item--error-message">
                    {errors.address?.postal_code.message}
                  </div>
                )}
              </div>
            </div>
            <div className="form-item">
              <label htmlFor="edit-address-organization">Organization</label>
              <input
                className={clsx(
                  'form-text',
                  errors.address?.organization && 'error'
                )}
                id="edit-address-organization"
                placeholder=" "
                type="text"
                size={60}
                {...register('address.organization', {
                  validate: (value) => {
                    if (value && value.length > 35) {
                      return 'Field is limited to 35 characters'
                    }
                    return undefined
                  },
                })}
              />
              {errors.address?.organization && (
                <div className="form-item--error-message">
                  {errors.address?.organization.message}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="form-item">
          <label htmlFor="edit-phone">Phone number</label>
          <input
            className={clsx('form-tel', errors.phone && 'error')}
            id="edit-phone"
            placeholder=" "
            size={30}
            type="tel"
            {...register('phone', {
              validate: (value) => {
                if (!value) {
                  return 'Field is required'
                }
                if (value.length > 20) {
                  return 'Field is limited to 20 characters'
                }
                if (!isMobilePhone(value, 'en-US')) {
                  return 'Valid phone number required, e.g. 212-555-1212'
                }
                return undefined
              },
            })}
          />
          {errors.phone && (
            <div className="form-item--error-message">
              {errors.phone.message}
            </div>
          )}
        </div>
      </div>
    </fieldset>
  </div>
)

export default ShippingAddressAndPhoneNumber
